import { render, staticRenderFns } from "./SbxPCC_Wrapper.vue?vue&type=template&id=4b7944a4&scoped=true&"
import script from "./SbxPCC_Wrapper.vue?vue&type=script&lang=js&"
export * from "./SbxPCC_Wrapper.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./SbxPCC_Wrapper.vue?vue&type=style&index=0&id=4b7944a4&prod&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "4b7944a4",
  null
  ,true
)

export default component.exports